import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import base64EyeIcon from './base64EyeIcon';

import './field-text.scss';

const FieldText = (props) => {
    const {
        className,
        forceUpperCase,
        ariaDescribedby,
        form,
        id,
        field,
        hint,
        label,
        ariaLabel,
        type,
        min,
        ...other
    } = props;

    const fieldName = field.name;
    const fieldId = id || fieldName;
    const error = form.errors[fieldName];
    const isInvalid = error !== undefined && error !== null;
    const isTouched = !!form.touched[fieldName];
    const showError = isTouched && isInvalid;
    const fieldTextClassName = classNames('field-text', {
        'field-text--invalid': showError,
        'field-text--uppercase': forceUpperCase,
    }, className);
    const inputProps = {};
    if (ariaLabel) {
        inputProps['aria-label'] = ariaLabel;
    }
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className={fieldTextClassName}>
            <div className="field-text__desc">
                {
                    label ?
                        <label className="field-text__label" htmlFor={fieldId}>{label}</label>
                        :
                        null
                }
                <div id={`${fieldId}-hint`} className="field-text__hint">
                    {
                        !showError ?
                            <span>{hint}</span>
                            :
                            null
                    }
                </div>
                <div id={`${fieldId}-errors`} className="field-text__errors">
                    {
                        showError ?
                            <span>{error}</span>
                            :
                            null
                    }
                </div>
            </div>
            <div className="field-text__input-container">
                <input
                    {...field}
                    {...other}
                    {...inputProps}
                    aria-describedby={`${fieldId}-errors ${fieldId}-hint ${ariaDescribedby}`}
                    aria-invalid={isInvalid}
                    id={fieldId}
                    className="field-text__input"
                    min={min}
                    type={type === 'password'

                        ? ((showPassword && 'text') || 'password')
                        : type}
                />
                {type === 'password' ?
                    <button type="button" className="field-text__toggle-password" onClick={handleTogglePasswordVisibility} >
                        <img
                            src={base64EyeIcon}
                            alt="base64EyeIcon"
                        />
                    </button>
                    : ''}
            </div>
        </div>
    );
};

FieldText.propTypes = {
    ariaDescribedby: PropTypes.string,
    className: PropTypes.string,
    forceUpperCase: PropTypes.bool,
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.number,
            PropTypes.shape({}),
            PropTypes.string,
        ]),
    }).isRequired,
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
        ])),
        touched: PropTypes.objectOf(PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({}),
            PropTypes.array,
        ])),
    }).isRequired,
    hint: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    min: PropTypes.number,
    ariaLabel: PropTypes.string,
};

FieldText.defaultProps = {
    ariaDescribedby: '',
    className: '',
    forceUpperCase: false,
    hint: '',
    label: '',
    id: '',
    type: 'text',
    ariaLabel: '',
    min: undefined,
};

export default FieldText;
